export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 3.5a1.001 1.001 0 01.687 1.727L13 13.43V19h4v2H7v-2h4v-5.57L2.314 5.227A1 1 0 013 3.5h18zm-9 8.125L18.485 5.5H5.515L12 11.625z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};